"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postLabel = void 0;
/**
 * Display label for a post in lists and confirmations.
 *
 * `subject` is only an input for blog and YouTube posts, where it is the
 * title; social posts leave it empty. Everything that lists posts needs a
 * fallback, and this is the single rule for it.
 */
const postLabel = (post) => { var _a, _b; return ((_a = post.subject) === null || _a === void 0 ? void 0 : _a.trim()) || ((_b = post.content) === null || _b === void 0 ? void 0 : _b.trim().slice(0, 50)) || "Untitled"; };
exports.postLabel = postLabel;
